import {
  DATA_CONNECTOR_XANO_UPDATE_COLLECTION_BEGIN,
  DATA_CONNECTOR_XANO_UPDATE_COLLECTION_SUCCESS,
  DATA_CONNECTOR_XANO_UPDATE_COLLECTION_FAILURE,
  DATA_CONNECTOR_XANO_UPDATE_COLLECTION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';

export function xanoUpdateCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_XANO_UPDATE_COLLECTION_BEGIN,
    });
    const { projectId, version, dataforupdate } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano/update-collection`,
        dataforupdate,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_XANO_UPDATE_COLLECTION_SUCCESS,
            data: res.data,
          });
          toast.success('Updated Successfully !');
          resolve(res);
        },

        (err) => {
          dispatch({
            type: DATA_CONNECTOR_XANO_UPDATE_COLLECTION_FAILURE,
            data: { error: err },
          });
          toast.error(`Updation Failed !`);
          reject(err);
        },
      );
    });

    return promise;
  };
}


export function dismissXanoUpdateCollectionError() {
  return {
    type: DATA_CONNECTOR_XANO_UPDATE_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_XANO_UPDATE_COLLECTION_BEGIN:

      return {
        ...state,
        xanoUpdateCollectionPending: true,
        xanoUpdateCollectionError: null,
      };

    case DATA_CONNECTOR_XANO_UPDATE_COLLECTION_SUCCESS:

      return {
        ...state,
        xanoUpdateCollectionPending: false,
        xanoUpdateCollectionError: null,
      };

    case DATA_CONNECTOR_XANO_UPDATE_COLLECTION_FAILURE:

      return {
        ...state,
        xanoUpdateCollectionPending: false,
        xanoUpdateCollectionError: action.data.error,
      };

    case DATA_CONNECTOR_XANO_UPDATE_COLLECTION_DISMISS_ERROR:

      return {
        ...state,
        xanoUpdateCollectionError: null,
      };

    default:
      return state;
  }
}
